/**
 * API Request Response Types
 */
import { MessageAttributesType, MessageParticipantRole, MessageType } from './sharedTypes';
import { ConnectionRequestSchema, EndRequestSchema, MessageMetadataSchema, SendMessageRequestSchema, TranscriptRequestSchema } from '../schemas/apiRequestSchemas';
import { z } from 'zod';

export type ConnectionRequest = z.input<typeof ConnectionRequestSchema>;

export type ConnectionResponse = {
    websocket: string;
};

export type SendMessageRequest = z.infer<typeof SendMessageRequestSchema>;

export type MessageMetadata = z.infer<typeof MessageMetadataSchema>;

export type ResponseMessage = {
    sessionId: string;
    type: MessageType;
    messageId: string;
    content?: string;
    contentType: string;
    attributes?: MessageAttributesType;
    displayName: string;
    participantRole: MessageParticipantRole;
    absoluteTime: number;
    messageMetadata?: MessageMetadata;
};

export type SendMessageResponse = {
    message?: ResponseMessage;
};

export type EndRequest = z.input<typeof EndRequestSchema>;

export enum TranscriptScanDirection {
    FORWARD = 'FORWARD',
    BACKWARD = 'BACKWARD',
}

export enum TranscriptSortOrder {
    DESCENDING = 'DESCENDING',
    ASCENDING = 'ASCENDING',
}

export type TranscriptRequest = z.infer<typeof TranscriptRequestSchema>

export type TranscriptResponse = {
    sessionId: string;
    nextToken?: string;
    transcript: ResponseMessage[];
};
